
import React, { MouseEventHandler } from "react";
import { SelectOptionItem } from "../../Select";
import classNames from "classnames";

interface SelectOptionProps {
  id: string;
  option: SelectOptionItem;
  onClick: MouseEventHandler<HTMLDivElement>;
  isSelected: boolean;
  isFocused?: boolean;
  dataCy?: string;
}

const SelectOption = ({
  id,
  option,
  onClick,
  isSelected,
  isFocused,
  dataCy,
}: SelectOptionProps) => {
  return (
    <div
      id={id}
      data-cy={dataCy}
      role="option"
      aria-selected={isSelected}
      onClick={onClick}
      className={classNames(
        "flex items-center gap-2 px-3 py-2 text-sm transition",
        "cursor-pointer",
        isSelected
          ? "bg-primary-50 text-primary-700 dark:bg-primary-500/10 dark:text-primary-300"
          : isFocused
            ? "bg-content-50 text-content-700 dark:bg-content-700/50 dark:text-content-200"
            : "text-content-700 hover:bg-content-50 dark:text-content-200 dark:hover:bg-content-700/50",
      )}
    >
      {option?.prefix && (
        <div className="shrink-0">{React.cloneElement(option?.prefix)}</div>
      )}
      <span className={classNames("truncate", isSelected && "font-medium")}>
        {option.label}
      </span>
      {isSelected && (
        <div className="icon-[ph--check] ml-auto h-4 w-4 shrink-0 text-primary-500 dark:text-primary-400" />
      )}
    </div>
  );
};

export default SelectOption;
